// Мгновенное применение стилей для hideUI
(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const hideUI = urlParams.get('pdHideUI');

  if (hideUI === 'true' || hideUI === '1') {
    console.log('hideUI detected', hideUI);
    document.documentElement.classList.add('hide-ui-initial');
  }
})();
